"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snapshotEqual = void 0;
var firestore_1 = require("firebase/firestore");
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */
var snapshotEqual = function (
// ! DocumentSnapshot<User> does not extends DocumentSnapshot<MetaType>...why? same case with QuerySnapshot
// eslint-disable-next-line @typescript-eslint/no-explicit-any
left, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
right) {
    return (0, firestore_1.snapshotEqual)(
    // @ts-expect-error
    left, right);
};
exports.snapshotEqual = snapshotEqual;
